/**
 * Hub app shell chrome (module header in Layout). Keep {@link HUB_APP_SHELL_SUBCHROME_STICKY_TOP_CLASS}
 * in sync when changing header vertical padding or nav link size.
 */
export const HUB_APP_SHELL_HEADER_Z_INDEX = 35;

export const hubAppShellHeaderClassName =
  "sticky top-0 z-[35] border-b border-slate-200 bg-white";

/** Tailwind top offset for a second sticky row under the shell header (~py-2 + nav row). */
export const HUB_APP_SHELL_SUBCHROME_STICKY_TOP_CLASS = "top-14";

export const HUB_APP_SHELL_SUBCHROME_Z_INDEX = 30;

export const hubAppShellSubchromeStickyClassName = "sticky top-14 z-[30]";
